import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const UnitNumber00Table: GenericTableSchemaInterface = {
  id: 'unitnumber-00',
  name: 'Unit Number 00',
  description: 'This table contains data around the unit number integration.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: VarKey.OrgName
    },
    c02: {
      name: 'Facility ID',
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: 'Start'
    },
    c04: {
      name: 'Get Tenant'
    },
    c05: {
      name: 'User Found'
    },
    c06: {
      name: 'Unit Number Found'
    },
    c07: {
      name: 'Account Past Due'
    },
    c08: {
      name: 'Account Inactive'
    },
    c09: {
      name: 'SMS Sent'
    },
    c10: {
      name: 'SMS Invalid Phone Number'
    },
    c11: {
      name: 'Email Sent'
    },
    c12: {
      name: 'Account Active'
    },
    c13: {
      name: 'Account Unknown'
    },
    c14: {
      name: 'Account "ELSE"'
    },
    c15: {
      name: 'Account Balance',
      variable: VarKey.LeaseBalance
    }
  }
}
